import { ButtonProps } from "@mui/material";

import { Color } from "../../../../../components/Form/Button";
import { Location } from "../../../../../models/location";

enum DespatchViewNavigation {
  DETAILS = "Details",
  PRODUCTS = "Products",
  SHIPPING_ITEMS = "ShippingItems",
  TRUCK = "Truck",
}

type DespatchViewTab = {
  key: string;
  label: string;
  loading?: boolean;
  isEmpty?: boolean;
  isOpened?: boolean;
  render: () => React.ReactChild;
  renderLoading?: () => React.ReactChild;
};

type DespatchViewMNavigationMenuItem = {
  key: string;
};

interface DespatchViewButtonItem extends Omit<ButtonProps, "color"> {
  buttonLabel: string;
  titlePage: string;
  class?: string;
  icon: React.ReactChild;
  color: Color;
  renderLoading?: () => React.ReactChild;
  renderComponent: () => React.ReactChild;
}

const getLocationArray = (location?: Location) => {
  if (!location) return [];

  return [location];
};

export { DespatchViewNavigation, getLocationArray };

export type { DespatchViewTab, DespatchViewMNavigationMenuItem, DespatchViewButtonItem };
